import { render, staticRenderFns } from "./UserValidSettingComponent.vue?vue&type=template&id=33c92e45&"
import script from "./UserValidSettingComponent.vue?vue&type=script&lang=js&"
export * from "./UserValidSettingComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports